module.exports = __webpack_public_path__ + "static/media/hint_image_space.7e5e192d.png";